import React, { useEffect, useState } from 'react';
import './i18n';
import './App.css';
import Header from './Components/Header';
import About from './Components/About';
import Resume from './Components/Resume';
import Testimonials from './Components/Testimonials';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
import Marquee from './Components/Marquee';
import Stats from './Components/Stats';
import ScrollProgress from './Components/ScrollProgress';
import ScrollToTop from './Components/ScrollToTop';

function App() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 30);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`app-shell ${loaded ? 'is-loaded' : ''}`}>
      <div className="bg-aurora" aria-hidden="true">
        <div className="aurora aurora-1" />
        <div className="aurora aurora-2" />
        <div className="aurora aurora-3" />
        <div className="aurora-grid" />
      </div>
      <ScrollProgress />
      <Header />
      <Marquee />
      <main>
        <About />
        <Stats />
        <Resume />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default App;
